__turbopack_context__.v({
  "Category": "bxjMhG_Category",
  "Compact": "bxjMhG_Compact",
  "Date": "bxjMhG_Date",
  "Details": "bxjMhG_Details",
  "EventCardButton": "bxjMhG_EventCardButton",
  "Footer": "bxjMhG_Footer",
  "FooterContent": "bxjMhG_FooterContent",
  "GuestActs": "bxjMhG_GuestActs",
  "Image": "bxjMhG_Image",
  "Location": "bxjMhG_Location",
  "Notification": "bxjMhG_Notification",
  "Title": "bxjMhG_Title",
  "Wrapper": "bxjMhG_Wrapper",
});
